// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ExploreContent,
    ExploreContentFromJSON,
    ExploreContentToJSON,
} from '../models';

export interface ContentsReadRequest {
    id: string;
}

export interface ContentsSlugsOnlyRequest {
    id: string;
}

/**
 * no description
 */
export class ExploreContentsApi extends runtime.BaseAPI {

    /**
     * Return content, section and slabs with items
     */
    async contentsReadRaw(requestParameters: ContentsReadRequest): Promise<runtime.ApiResponse<ExploreContent>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsRead.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("LabXChange API", ["read", "write"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/explore_contents/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ExploreContentFromJSON(jsonValue));
    }

    /**
     * Return content, section and slabs with items
     */
    async contentsRead(requestParameters: ContentsReadRequest): Promise<ExploreContent> {
        const response = await this.contentsReadRaw(requestParameters);
        return await response.value();
    }

    /**
     * Returns explore sections slab without item details.
     */
    async contentsSlugsOnlyRaw(requestParameters: ContentsSlugsOnlyRequest): Promise<runtime.ApiResponse<ExploreContent>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsSlugsOnly.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("LabXChange API", ["read", "write"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/explore_contents/{id}/slugs_only`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ExploreContentFromJSON(jsonValue));
    }

    /**
     * Returns explore sections slab without item details.
     */
    async contentsSlugsOnly(requestParameters: ContentsSlugsOnlyRequest): Promise<ExploreContent> {
        const response = await this.contentsSlugsOnlyRaw(requestParameters);
        return await response.value();
    }

}
